<template>
  <div>
    <a-button class="editable-add-btn" @click="showAddDomainModal()" v-if="!hasCustomDomains">Add custom domain</a-button>
    <a-modal
      :title="dmTitle"
      v-model="dmVisible"
      @cancel="handleDomainStatusModalCancel"
      :footer="null"
      width="50%"
      :destroyOnClose="true"
    >
      <a-domain-status-modal 
      :dmSpinning="dmSpinning"
      :dmHasStatus="dmHasStatus"
      :dmStatus="dmStatus"
      :dmStatusError="dmStatusError" />
    </a-modal>

    <a-add-domain-modal
      ref="domainModalForm"
      :dfVisible="dfVisible"
      :dfTitle="dfTitle"
      @cancel="handleAddDomainFormCancel"
      @create="handleAddDomainFormCreate"
      v-if="!hasCustomDomains"
    />

    <a-skeleton active :loading="loading" :title="false" :paragraph="{ rows: 8, width: 800 }">
      <a-list
        :dataSource="allDomains"
        itemLayout="horizontal"
        :pagination="pagination"
        :grid="{ size: 'middle'}"
      >
        <a-list-item slot="renderItem" slot-scope="domain" :rowKey="domain.uuid">
          <div slot="actions" v-if="!domain.is_primary">
            <a-button type="dashed" @click="showDomainStatusModal(domain)">Details</a-button>
            <a-popconfirm
              @confirm="() => onRemoveDomain(domain)"
            >
            <p slot="title">
              Are you sure to remove custom <br> domain {{domain.domain}}?
            </p>
            <a href="javascript:;"><a-button type="danger" icon="delete">Remove</a-button></a>
            </a-popconfirm>
            <a-button
              slot="tabBarExtraContent"
              type="danger"
              :href="'https://developer.axioms.io/docs/getting-started/tenant/pages-endpoints/?domain='+domain.domain"
              target="_blank"
            >Tenant Urls <a-icon type="arrow-right" /></a-button>
          </div>
          <div slot="actions" v-else>
            <a-button
              slot="tabBarExtraContent"
              type="danger"
              :href="'https://developer.axioms.io/docs/getting-started/tenant/pages-endpoints/?domain='+domain.domain"
              target="_blank"
            >Tenant Urls <a-icon type="arrow-right" /></a-button>
          </div>
          <div class="container"></div>
          <a-list-item-meta class="clickable" :description="domain.description">
            <a
              slot="title"
              :href="'https://'+domain.domain+'/user/register'"
              target="_blank"
              rel="noopener noreferrer"
            >{{ domain.domain }}</a>
            <a-avatar
              slot="avatar"
              shape="square"
              icon="global"
              :size="48"
              style="background: #002e66;"
            />
            <div slot="description">
              <div v-if="!domain.is_primary">
                <a-icon type="safety" style="color:red;" />Custom Domain
              </div>
              <div v-else>
                <a-icon type="safety" style="color:green;" />Primar Domain
              </div>
            </div>
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </a-skeleton>
  </div>
</template>

<script>
import ADomainStatusModal from "@/components/Modal/ADomainStatusModal";
import AAddDomainModal from "@/components/Modal/AAddDomainModal";

export default {
  data() {
    return {
      loading: false,
      dmVisible: false,
      dmTitle: "Domain",
      dmHasStatus: false,
      dmSpinning: false,
      dmStatus: {
        status: "",
        acm_status: "",
        cname: "",
        proxy: "",
        hostname:""
      },
      dmStatusError: "",
      dfVisible: false,
      dfDomain: "",
      dfIsUpdate: false,
      dfTitle: "Add Custom Domain",
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: 10
      },
      subscription: {}
    };
  },

  components: {
    ADomainStatusModal,
    AAddDomainModal
  },

  computed: {
    allDomains() {
      return this.$store.state.core.tenants_item.domain_urls;
    },
    hasCustomDomains() {
      return this.allDomains.length == 2 ? true : false;
    },
    tenant() {
      return this.$store.state.core.tenants_item;
    }
  },

  methods: {
    handleDomainStatusModalCancel() {
      this.dmVisible = false;
      this.dmSpinning = false;
      this.dmStatus = {
        status: "",
        acm_status: "",
        cname: "",
        proxy: "",
        hostname:""
      };
      this.dmStatusError = "";
      this.dmHasStatus = false;
    },
    async handleAddDomainFormCreate() {
      const form = this.$refs.domainModalForm.form;
      form.validateFields(async (err, values) => {
        if (!err) {
          console.log(values);
          try {
            await this.$store.dispatch("core/createItem", {
              endpoint: `tenants/${this.tenant.uuid}/domains`,
              data: values
            });
            await this.$store.dispatch("core/getItem", {
              endpoint: "tenants",
              uuid: this.tenant.uuid
            });
            await this.$notification.open({
              message: "Domain added!",
              description: "Custom domain added to this tenant.",
              icon: (
                <a-icon type="check-circle" theme="filled" style="color: green" />
              )
            });
            this.handleAddDomainFormCancel();
            form.resetFields();
          } catch (error) {
            console.error(error);
            form.setFields({
              domain: {
                value: values.domain,
                errors: [new Error(error.response.data.domain[0])]
              }
            });
          }
        } else {
          console.error("Error! Check submitted values : ", values);
        }
      });
    },

    handleAddDomainFormCancel() {
      this.dfVisible = false;
    },

    async onRemoveDomain(domain) {
      try {
        await this.$store.dispatch("core/deleteItem", {
          endpoint: `tenants/${this.tenant.uuid}/domains`,
          uuid: domain.uuid
        });
        await this.$store.dispatch("core/getItem", {
          endpoint: "tenants",
          uuid: this.tenant.uuid
        });
        await this.$notification.open({
          message: "Domain removed!",
          description: "Custom domain removed from this tenant.",
          icon: (
            <a-icon type="check-circle" theme="filled" style="color: green" />
          )
        });
      } catch (error) {
        console.error(error);
        this.$notification.open({
          message: "Removal failed!",
          description: error.response.data.msg,
          icon: (
            <a-icon type="close-circle" theme="filled" style="color: red" />
          )
        });
      }
    },
    showAddDomainModal() {
      this.dfVisible = true;
    },
    async showDomainStatusModal(domain) {
      this.dmVisible = true;
      this.dmSpinning = true;
      this.dmTitle = domain.domain;
      try {
        var res = await this.$store.dispatch("core/getItems", {
          endpoint: `tenants/${this.tenant.uuid}/domains/${domain.uuid}/status`
        });
        this.dmStatus = res;
        this.dmHasStatus = true;
        this.dmSpinning = false;
      } catch (error) {
        console.error(error);
        this.dmSpinning = false;
        this.dmStatusError = error.response.data.msg;
      }
    },
    success() {
      this.$message.success("CNAME copied.", 5);
    }
  }
};
</script>

<style lang="css">
.editable-add-btn {
  margin-bottom: 10px;
}
.cname {
  display: inline-block;
  width: 90%;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  text-align: center;
  border-style: dashed;
  background: white;
  font-size: 1.1em;
}

.disabled {
  opacity: 0.7;
}
</style>
